import routerOptions0 from "/runner/_work/merpay-coupon-web-jp/merpay-coupon-web-jp/node_modules/.pnpm/nuxt@3.8.2_@opentelemetry+api@1.8.0_@parcel+watcher@2.4.1_@types+node@20.5.1_@unocss+reset@0._b2cnb624k2imfpktwbb6ogfova/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}